import {
  SwipeableDrawer,
  Drawer,
  Collapse,
  Avatar,
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField,
  makeStyles,
  FormControl,
  MenuItem,
  Select,
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  Card,
  CardActionArea,
  Chip,
  CardMedia,
  CardContent,
  Popover,
  Modal,
  Breadcrumbs,
  Button,
  Link,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
  InputAdornment,
  Tabs,
  Tab,
  Box,
  Slider,
  Typography,
  Menu,
  Container,
  OutlinedInput,
  RadioGroup,
  Radio,
  Switch,
  FormLabel,
} from "@material-ui/core";
import {
  Autocomplete,
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  TimelineSeparator,
} from "@material-ui/lab";
import {
  Stepper,
  Step,
  StepLabel,
  FormControlLabel,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import {
  DatePicker,
  DesktopDatePicker,
  TimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default {
  SwipeableDrawer,
  Timeline,
  Typography,
  TimelineConnector,
  TimelineContent,
  TimelineItem,
  Container,
  TimelineSeparator,
  Collapse,
  Accordion,
  Backdrop,
  OutlinedInput,
  Menu,
  Checkbox,
  Tab,
  Box,
  InputAdornment,
  AccordionDetails,
  Autocomplete,
  AccordionSummary,
  Avatar,
  DialogTitle,
  DialogContent,
  Tabs,
  DialogActions,
  TextField,
  makeStyles,
  FormControl,
  MenuItem,
  Select,
  CircularProgress,
  Dialog,
  IconButton,
  Divider,
  CardActionArea,
  Chip,
  Card,
  CardMedia,
  CardContent,
  Popover,
  Modal,
  Breadcrumbs,
  Link,
  Button,
  Slider,
  Stepper,
  Step,
  StepLabel,
  DatePicker,
  DesktopDatePicker,
  TimePicker,
  LocalizationProvider,
  AdapterDateFns,
  FormControlLabel,
  Drawer,
  RadioGroup,
  Radio,
  Switch,
  FormLabel,
  ToggleButtonGroup,
  ToggleButton,
};
